import { PlanDetails } from '../containers/plans/types';

export const generateOrganizationSchema = () => ({
	'@context': 'https://schema.org',
	'@type': 'Organization',
	'name': 'DIYFeed',
	'url': 'https://www.diyfeed.com',
	'logo': 'https://www.diyfeed.com/logo-main.svg',
	'description': 'DIY project inspiration and materials marketplace',
	'sameAs': [
		'https://diyfeed.com'
	]
});

export const generateProductSchema = (plan: PlanDetails) => ({
	'@context': 'https://schema.org',
	'@type': 'Product',
	'name': plan.title,
	'description': plan.description,
	'image': plan.images?.map(img => img.imgUrl) || [],
	'brand': {
		'@type': 'Brand',
		'name': plan.author.name || 'DIYFeed'
	},
	'offers': plan.materialsCost ? {
		'@type': 'Offer',
		'price': plan.materialsCost,
		'priceCurrency': 'USD',
		'availability': 'https://schema.org/InStock'
	} : undefined,
//   "aggregateRating": plan.ratingsSummary ? {
//     "@type": "AggregateRating",
//     "ratingValue": plan.ratingsSummary.averageRating,
//     "reviewCount": plan.ratingsSummary.totalRatings
//   } : undefined
});

export const generateHowToSchema = (plan: PlanDetails) => ({
	'@context': 'https://schema.org',
	'@type': 'HowTo',
	'name': plan.title,
	'description': plan.description,
	'image': plan.images?.map(img => img.imgUrl) || [],
	'estimatedCost': plan.materialsCost ? {
		'@type': 'MonetaryAmount',
		'currency': 'USD',
		'value': plan.materialsCost
	} : undefined,
	'totalTime': plan.timeCost ? `PT${plan.timeCost}M` : undefined,
	'supply': plan.tools?.map(tool => ({
		'@type': 'HowToSupply',
		'name': tool.name
	})) || [],
	'step': plan.instructions ? [{
		'@type': 'HowToStep',
		'text': plan.instructions
	}] : []
});

export const generateBreadcrumbSchema = (items: Array<{name: string, url: string}>) => ({
	'@context': 'https://schema.org',
	'@type': 'BreadcrumbList',
	'itemListElement': items.map((item, index) => ({
		'@type': 'ListItem',
		'position': index + 1,
		'name': item.name,
		'item': item.url
	}))
});
